
    import * as React from 'react';

    const Tag16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M7.5 5A2.5 2.5 0 115 2.5 2.5 2.5 0 017.5 5zm-.938 0a1.562 1.562 0 10-3.124 0 1.562 1.562 0 003.124 0zM13.5 5A2.5 2.5 0 1111 2.5 2.5 2.5 0 0113.5 5zm-.938 0a1.562 1.562 0 10-3.124 0 1.562 1.562 0 003.124 0zm.938 6A2.5 2.5 0 1111 8.5a2.5 2.5 0 012.5 2.5zm-.938 0a1.562 1.562 0 10-3.124 0 1.562 1.562 0 003.124.002zM7.5 11A2.5 2.5 0 115 8.5 2.5 2.5 0 017.5 11zm-.938 0a1.562 1.562 0 10-3.124 0 1.562 1.562 0 003.124 0z" /></svg>
        </div>
      );
    };

    Tag16.displayName = 'Tag16';

    export default Tag16;
  